"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _constants = require("react-dates/constants");
var _downshift = _interopRequireDefault(require("downshift"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _moment = _interopRequireDefault(require("moment"));
var R = _interopRequireWildcard(require("ramda"));
var _reactDeviceDetect = require("react-device-detect");
var _handlers = require("../../../../../../helpers/handlers");
var _DateControl = require("../../../../../DateControl");
var _Input = _interopRequireDefault(require("../../../../../ui/Input"));
var _Label = _interopRequireDefault(require("../../../../../ui/Label"));
var _calendar = _interopRequireDefault(require("./img/calendar.svg"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var DATE_MASK = [/[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];
var DATE_FORMAT = 'DD.MM.YYYY';
var EMPTY_MOMENT_VALUE = undefined;
var isBlocked = function isBlocked(day) {
  return day.clone().isAfter((0, _moment.default)().startOf('day'), 'day');
};
var moment2String = function moment2String(momentDate) {
  return momentDate.format(DATE_FORMAT);
};
var toMoment = function toMoment(date) {
  return (0, _moment.default)(date, DATE_FORMAT);
};
var isValidDateString = function isValidDateString(date) {
  return (0, _moment.default)(date, DATE_FORMAT, true).isValid();
};
var getInitialMonth = function getInitialMonth(from, to, focus) {
  return _reactDeviceDetect.isMobileOnly ? R.call(R.cond([[R.equals(_constants.START_DATE), function () {
    return from ? from.clone() : (0, _moment.default)();
  }], [R.equals(_constants.END_DATE), function () {
    return to ? to.clone() : (0, _moment.default)();
  }], [R.T, function () {
    return (0, _moment.default)();
  }]]), focus) : from ? from.clone() : (0, _moment.default)().subtract(1, 'months');
};
var DatesControl = function DatesControl(_ref) {
  var initialFrom = _ref.from,
    initialTo = _ref.to,
    onChange = _ref.onChange;
  var _useTranslation = (0, _reactI18next.useTranslation)('BASKETS_SEARCH_FORM'),
    t = _useTranslation.t;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(undefined),
    _useState4 = _slicedToArray(_useState3, 2),
    focus = _useState4[0],
    setFocus = _useState4[1];
  var _useState5 = (0, _react.useState)(initialFrom ? toMoment(initialFrom) : undefined),
    _useState6 = _slicedToArray(_useState5, 2),
    from = _useState6[0],
    setFrom = _useState6[1];
  var _useState7 = (0, _react.useState)(initialTo ? toMoment(initialTo) : undefined),
    _useState8 = _slicedToArray(_useState7, 2),
    to = _useState8[0],
    setTo = _useState8[1];
  var _useState9 = (0, _react.useState)(initialFrom),
    _useState0 = _slicedToArray(_useState9, 2),
    fromInputValue = _useState0[0],
    setFromInputValue = _useState0[1];
  var _useState1 = (0, _react.useState)(initialTo),
    _useState10 = _slicedToArray(_useState1, 2),
    toInputValue = _useState10[0],
    setToInputValue = _useState10[1];
  var fromRef = (0, _react.useRef)();
  var toRef = (0, _react.useRef)();
  var onChangeProxy = (0, _react.useCallback)(function () {
    setFrom(function (nextFrom) {
      setTo(function (nextTo) {
        var stringFrom = nextFrom ? moment2String(nextFrom) : '';
        var stringTo = nextTo ? moment2String(nextTo) : '';
        onChange(stringFrom, stringTo);
        return nextTo;
      });
      return nextFrom;
    });
  }, [onChange]);
  var handleFocusChange = (0, _react.useCallback)(function (nextFocus) {
    setFocus(nextFocus);
    var handler = R.cond([[R.equals(_constants.START_DATE), function () {
      return fromRef.current.focus();
    }], [R.equals(_constants.END_DATE), function () {
      return toRef.current.focus();
    }], [R.T, function () {
      setIsOpen(false);
    }]]);
    handler(nextFocus);
  }, []);
  var onDatesChange = (0, _react.useCallback)(function (_ref2) {
    var startDate = _ref2.startDate,
      endDate = _ref2.endDate;
    if (startDate) {
      setFrom(startDate);
      setFromInputValue(moment2String(startDate));
    }
    if (endDate) {
      setTo(endDate);
      setToInputValue(moment2String(endDate));
    }
    onChangeProxy();
  }, [onChangeProxy]);
  var onChangeFromInput = (0, _react.useCallback)(function (stringFromDate) {
    setFromInputValue(stringFromDate);
    if (isValidDateString(stringFromDate)) {
      setFrom(toMoment(stringFromDate));
      onChangeProxy();
    }
  }, [onChangeProxy]);
  var onClearFromInput = (0, _react.useCallback)(function () {
    setFrom(EMPTY_MOMENT_VALUE);
    setFromInputValue('');
    onChangeProxy();
  }, [onChangeProxy]);
  var onChangeToInput = (0, _react.useCallback)(function (stringToDate) {
    setFromInputValue(stringToDate);
    if (isValidDateString(stringToDate)) {
      setTo(toMoment(stringToDate));
      onChangeProxy();
    }
  }, [onChangeProxy]);
  var onClearToInput = (0, _react.useCallback)(function () {
    setTo(EMPTY_MOMENT_VALUE);
    setToInputValue('');
    onChangeProxy();
  }, [onChangeProxy]);
  var onOuterClick = (0, _react.useCallback)(function () {
    setIsOpen(false);
  }, []);
  return /*#__PURE__*/_react.default.createElement(_Label.default, {
    clickable: false,
    text: t('DATES_CONTROL_LABEL')
  }, /*#__PURE__*/_react.default.createElement(_downshift.default, {
    isOpen: isOpen,
    onOuterClick: onOuterClick
  }, function () {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _styles.default.inputs
    }, /*#__PURE__*/_react.default.createElement(_Input.default, {
      className: _styles.default.input,
      icon: from ? undefined : _calendar.default,
      mask: DATE_MASK,
      ref: fromRef,
      value: fromInputValue,
      onChange: onChangeFromInput,
      onClear: from ? onClearFromInput : undefined,
      onClick: (0, _handlers.handleWith)(function () {
        return setIsOpen(true);
      }, function () {
        return setFocus(_constants.START_DATE);
      })
    }), /*#__PURE__*/_react.default.createElement(_Input.default, {
      className: _styles.default.input,
      icon: to ? undefined : _calendar.default,
      mask: DATE_MASK,
      ref: toRef,
      value: toInputValue,
      onChange: onChangeToInput,
      onClear: to ? onClearToInput : undefined,
      onClick: (0, _handlers.handleWith)(function () {
        return setIsOpen(true);
      }, function () {
        return setFocus(_constants.END_DATE);
      })
    }), isOpen && /*#__PURE__*/_react.default.createElement("div", {
      className: _styles.default.dropdown
    }, /*#__PURE__*/_react.default.createElement(_DateControl.DatesRangeControl, {
      hideKeyboardShortcutsPanel: true,
      endDate: to,
      focusedInput: focus,
      initialVisibleMonth: function initialVisibleMonth() {
        return getInitialMonth(from, to, focus);
      },
      isDayBlocked: isBlocked,
      maxDate: (0, _moment.default)().add(1, 'day'),
      minimumNights: 0,
      numberOfMonths: _reactDeviceDetect.isMobileOnly ? 1 : 2,
      startDate: from,
      onDatesChange: onDatesChange,
      onFocusChange: handleFocusChange
    })));
  }));
};
DatesControl.propTypes = {
  from: _propTypes.default.string.isRequired,
  to: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func.isRequired
};
var _default = exports.default = (0, _react.memo)(DatesControl);